import React from "react";

export const SuccessfullBanner = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-b from-primary-1100 to-primary-1000">
      {/* <img src="/images/svg/moneyhop-logo.svg" alt="sbm-white-logo" width="457px" height="115px" /> */}
      <div className="text-[32px] font-bold text-black my-11">Signup Successfull</div>
      <div className="text-2xl font-bold text-primary-1150">Getting you there.......</div>
      <div className="w-[22%] text-2xl font-normal text-primary-1150 mt-7 text-center">
        We are creating your profile, hold back and relax!
      </div>
    </div>
  );
};
